import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    getProductMarkerNormalAsync,
    getProductMarkerHoverAsync,
    getVideoMarkerNormalAsync
} from '../../utils/StaticAssetManager.js';
import Marker from './Marker.jsx';
import ComposableModal from '../ui/modals/composable/ComposableModal.jsx';
import HotspotCircle from './ReactSVGHotspots/HotspotCircle';
import HotspotPlus from './ReactSVGHotspots/HotspotPlus';
import ModalHotspotCircle from './ReactSVGHotspots/ModalHotspotCircle.jsx';
import { getHotspotIconStyle } from '../../utils/StoreConfigManager.js';
import { getIconSVGAsync } from '../ui/ui-layer-panel/SVGIcons.jsx';
import TextModal from '../ui/modals/text/TextModal';
import { ModalTypes } from '../ui/modals/utils/ModalConstants';
import IframeModal from '../ui/modals/iframe/IframeModal.jsx';
import { storeId } from '../../../../variables/DevVariables.js';
import { popupStoreId, exhibitStoreId } from '../../utils/StoreConfigManager.js';
import { TextPopUpHotSpotClicked } from '../../utils/Analytics.js';
import ExhibitTextModal from '../ui/modals/text/ExhibitTextModal.jsx';

export const ModalMarkerTypes = Object.freeze({
    Image: "image",
    Video: "video",
    TextModal: 'text_with_button',
    IFrameModal: 'iframe'
});

export const MarkerImageAssets = Object.freeze({
    VideoMarker: "https://cdn.obsess-vr.com/play-icon.svg",
    ImageMarker: "https://cdn.obsess-vr.com/umg/template-image-hotspot-icon-2.svg",
    PokemonCustomHotspot: "https://cdn.obsess-vr.com/umg/pokeball-hotspot-icon.svg",
    ContentHotspot: "https://cdn.obsess-vr.com/umg/vinyl-icon.svg" //lacma
});

class ModalMarker extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);

        this.state = {
            isShowingModal: false,
            normalSpriteUrl: '',
            hoverSpriteUrl: '',
            svgSprite: null,
            svgSpriteString: ''
        };
        this.mounted = false;
        switch (props.type) {
            case ModalMarkerTypes.Video:
                if(storeId !== popupStoreId)
                this.setSVGIcon(MarkerImageAssets.VideoMarker);
                else
                this.setPokemonCustomSVGIcon(MarkerImageAssets.PokemonCustomHotspot)
                break;
            case ModalMarkerTypes.Image:
                if(storeId !== popupStoreId)
                this.setSVGSpriteIcon();
                else
                this.setPokemonCustomSVGIcon(MarkerImageAssets.PokemonCustomHotspot)
                break;
            case ModalMarkerTypes.TextModal:
                if(storeId === popupStoreId){
                    this.setPokemonCustomSVGIcon(MarkerImageAssets.PokemonCustomHotspot)
                }
                else if(storeId === exhibitStoreId){
                    this.setPokemonCustomSVGIcon(MarkerImageAssets.ContentHotspot)
                }
                else{
                    this.setSVGSpriteIcon();
                }
                break;
            case ModalMarkerTypes.IFrameModal:
                if(storeId !== popupStoreId)
                this.setSVGSpriteIcon();
                else
                this.setPokemonCustomSVGIcon(MarkerImageAssets.PokemonCustomHotspot)
                break;
            default:
                getProductMarkerNormalAsync()
                .then(url => {
                    if(storeId === popupStoreId)
                        this.setPokemonCustomSVGIcon(MarkerImageAssets.PokemonCustomHotspot)
                    else
                        this.setState({ normalSpriteUrl: url })
                })
                .catch(error => console.error(error));
                getProductMarkerHoverAsync()
                .then(url => {
                    if(storeId === popupStoreId)
                        this.setPokemonCustomSVGIcon(MarkerImageAssets.PokemonCustomHotspot)
                    else
                    this.setState({ hoverSpriteUrl: url })
                })
                .catch(error => console.error(error));
                getHotspotIconStyle()
                .then(icon => {
                    if(storeId === popupStoreId)
                        this.setPokemonCustomSVGIcon(MarkerImageAssets.PokemonCustomHotspot)
                    else{
                        const Sprite = icon == 'blank' ? HotspotCircle : HotspotPlus;
                        this.setState({ svgSprite: Sprite });
                    }
                })
                .catch(error => console.error(error));
                break;
        }
    }

    setPokemonCustomSVGIcon(markerIconUrl) {
        getIconSVGAsync(null, markerIconUrl)
        .then(svgString => this.setState({ svgSpriteString: svgString }))
        .catch(error => console.error(error));
    }

    setSVGIcon(markerIconUrl) {
        getIconSVGAsync(null, markerIconUrl)
        .then(svgString => this.setState({ svgSpriteString: svgString }))
        .catch(error => console.error(error));
    }

    setSVGSpriteIcon(){
        getHotspotIconStyle()
        .then(icon => {
            const Sprite = icon == 'blank' ? ModalHotspotCircle : HotspotPlus;
            this.setState({ svgSprite: Sprite });
        })
        .catch(error => console.error(error));
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onClick() {
        if (!this.mounted) {
            return;
        }
        const { modalContent } = this.props;
        if(modalContent['hotspot_type'] === 'text_with_button'){
            const title = modalContent['title'] ? modalContent['title'] : modalContent['body'];
            TextPopUpHotSpotClicked(title);
        }
        this.setState({ isShowingModal: true });
    }

    onModalHidden() {
        if (!this.mounted) {
            return;
        }
        this.setState({ isShowingModal: false });
    }

    getTextModal() {
        if(storeId === exhibitStoreId){
            return (
                <ExhibitTextModal
                    modalContent={this.props.modalContent}
                    onModalHidden={this.onModalHidden}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            );
        }else
        {
            return (
                <TextModal
                    modalContent={this.props.modalContent}
                    onModalHidden={this.onModalHidden}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            );
        }
    }

    getComposableModal() {
        return (
            <ComposableModal
                type={this.props.type}
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
            />
        );
    }

    getIframeModal() {
        return (
            <IframeModal
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
            />
        )
    }

    renderModal() {
        if (this.state.isShowingModal && this.props.type) {
            switch (this.props.type) {
                case ModalTypes.TextModal:
                    return this.getTextModal();
                case ModalTypes.IFrameModal:
                    return this.getIframeModal();
                default:
                    return this.getComposableModal();
            }
        }
        return null;
    }

    render() {
        const { normalSpriteUrl, hoverSpriteUrl, svgSprite, svgSpriteString } = this.state;
        return (
            <div>
                {this.renderModal()}
                <Marker
                    transform={this.props.transform}
                    colliderTransform={this.props.colliderTransform}
                    normalSpriteUrl={normalSpriteUrl}
                    hoverSpriteUrl={hoverSpriteUrl}
                    svgSprite={svgSprite}
                    svgSpriteString={svgSpriteString}
                    showVisual={this.props.showVisual}
                    onClick={this.onClick}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                />
            </div>
        );
    }
}

ModalMarker.propTypes = {
    transform: PropTypes.array.isRequired,
    colliderTransform: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    modalContent: PropTypes.object.isRequired,
    showVisual: PropTypes.bool,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string
};

export default ModalMarker;
